import { render, staticRenderFns } from "./GContractList.vue?vue&type=template&id=d5327b94&"
import script from "./GContractList.vue?vue&type=script&lang=ts&"
export * from "./GContractList.vue?vue&type=script&lang=ts&"
import style0 from "./GContractList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports